// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__26DKL","content":"ManualTimeModal_content__DetmQ"};